import { Link } from "react-router-dom";
import { Menu, Moon, Sun } from "lucide-react";
import { useThemeMode } from "@/lib/theme";

const ThemeToggle = () => {
  const { theme, toggle } = useThemeMode();
  return (
    <button
      type="button"
      onClick={toggle}
      data-testid="theme-toggle-btn"
      aria-label={theme === "dark" ? "Svijetla tema" : "Tamna tema"}
      className="grid h-9 w-9 place-items-center rounded-md border border-border text-muted-foreground transition-colors hover:bg-elevated hover:text-foreground"
    >
      {theme === "dark" ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
    </button>
  );
};

export const AppHeader = ({ onMenu }) => (
  <header className="sticky top-0 z-40 flex h-16 items-center justify-between border-b border-border bg-background/85 px-4 backdrop-blur-md sm:px-6">
    <div className="flex items-center gap-3">
      <button
        type="button"
        onClick={onMenu}
        data-testid="mobile-menu-btn"
        aria-label="Izbornik"
        className="grid h-9 w-9 place-items-center rounded-md border border-border lg:hidden"
      >
        <Menu className="h-4 w-4" />
      </button>
      <Link to="/documentation" data-testid="brand-home-link" className="group flex items-center gap-3">
        <span className="grid h-8 w-8 place-items-center rounded-md bg-primary font-mono text-[11px] font-bold text-primary-foreground transition-transform duration-200 group-hover:-rotate-6">
          MB
        </span>
        <span className="leading-tight">
          <span className="block font-heading text-sm font-bold tracking-tight">MegaBooker AI OS</span>
          <span className="block font-mono text-[10px] uppercase tracking-[0.18em] text-muted-foreground">
            Pregled dokumentacije · G0-R odobren / G1a dopušten
          </span>
        </span>
      </Link>
    </div>
    <div className="flex items-center gap-2">
      <span
        data-testid="header-g0-status-pill"
        className="hidden items-center gap-2 rounded-full border border-warn/40 bg-warn/10 px-3 py-1 font-mono text-[10px] font-semibold uppercase tracking-[0.16em] text-warn sm:inline-flex"
      >
        <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-warn" />
        G0 odobren · G1a samo sintetički
      </span>
      <ThemeToggle />
    </div>
  </header>
);
